import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';

import { TaskService } from './../task.service';
import { ConstantsService } from 'app/services/constants-service';

@Component({
  selector: 'taskguide',
  templateUrl: './task-guide.component.html'
})


/**
 * Dialog component to show the task guide.
 */
export class TaskGuideComponent implements OnInit {
  guideText: string;
  title: string;
  taskDefId: string;
  flagGuideText = true;

  constructor(
    private taskService: TaskService,
    public dialogRef: MdDialogRef<any>,
  ) { }

  ngOnInit() {
    this.taskService.getTaskGuide(this.taskDefId).subscribe(
      response => {
        this.guideText =
          response.message || response.message === '' ?
            ConstantsService.TASK_GUIDE_DEFAULT_TEXT :
            response;
            this.flagGuideText = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/task/taskguide/task-guide.component.ts